import { render } from "./RegistroLecheFria.vue?vue&type=template&id=33c49e81"
import script from "./RegistroLecheFria.vue?vue&type=script&lang=js"
export * from "./RegistroLecheFria.vue?vue&type=script&lang=js"

import "./RegistroLecheFria.vue?vue&type=style&index=0&id=33c49e81&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/AccesoTransportistas/RegistroLecheFria.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33c49e81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33c49e81', __exports__)) {
    api.reload('33c49e81', __exports__)
  }
  
  module.hot.accept("./RegistroLecheFria.vue?vue&type=template&id=33c49e81", () => {
    api.rerender('33c49e81', render)
  })

}


export default __exports__